import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useAccountId } from '../../redux/slices/appInfo/hooks';
import { trackEvent } from '../analytics/sml/analytics';
import { TypedMemo } from '../common/types';
import { LoadingView } from '../common/views/LoadingView';
import { FullScreenUpgradeHost } from '../music24/components/SMLUpgradeModal/FullScreenUpgradeHost';
import { MusicVideoEditorScreen } from './MusicVideoEditorScreen';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the editor; each part uses its own slice of it */
import styles from './MusicVideoEditor.module.scss';
/* eslint-enable css-modules/no-unused-class */

/**
 * The music video editor route: `/app/catalog/song/:catalogItemUuid/music-video[?cut=&from=]`
 * (design music-video b1). It fills the screen: no app sidebar and no page head, only the editor
 * with its own top bar. Every call is account-scoped; the key starts a new editor for each artist
 * and each song.
 */
const MusicVideoEditorViewComponent: React.FC = () => {
  const accountId = useAccountId();
  const { catalogItemUuid } = useParams<{ catalogItemUuid: string }>();
  useEffect(() => {
    trackEvent('music_video_opened');
  }, []);
  return (
    <div className={styles.screen} data-fullscreen-editor>
      {accountId === null || catalogItemUuid === undefined ? (
        <LoadingView />
      ) : (
        <MusicVideoEditorScreen
          key={`${accountId}:${catalogItemUuid}`}
          accountId={accountId}
          catalogItemUuid={catalogItemUuid}
        />
      )}
      {/* This route has no `SMLContainer`: the upgrade prompt and the plan picker need their own mount. */}
      <FullScreenUpgradeHost />
    </div>
  );
};

export const MusicVideoEditorView = TypedMemo(MusicVideoEditorViewComponent);
